import { Component, Input, OnInit, inject } from '@angular/core';
import { SupportChatLauncherService } from 'src/app/support-system/services/support-chat-launcher.service';

/** "Do you need help?" bubble next to the support chat launcher, for trial users. */
@Component({
  selector: 'app-support-chat-nudge',
  templateUrl: './support-chat-nudge.component.html',
  styleUrls: ['./support-chat-nudge.component.css'],
})
export class SupportChatNudgeComponent implements OnInit {
  readonly supportChat = inject(SupportChatLauncherService);

  @Input() currentUser: any;

  public isEligible: boolean = false;
  public isOpenState: boolean = false;
  public dismissed: boolean = false;

  ngOnInit(): void {
    if (!this.currentUser?.is_7_days_free_trial) return;
    this.isEligible = true;
    setTimeout(() => {
      this.isOpenState = true;
    }, 1000);
  }

  public openChat(): void {
    this.dismissed = true;
    this.supportChat.open();
  }
}
